import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/invoicing",
    name: "homePage",
    component: () => import("../views/invoicing/homePage/Index.vue"),
    meta: {
      title: "开发票",
    },
  },
  {
    path: "/invoicingDetail",
    name: "invoicingDetail",
    component: () => import("../views/invoicing/detail/Index.vue"),
    meta: {
      title: "开发票",
    },
  },
  {
    path: "/toInvoicing",
    name: "toInvoicing",
    component: () => import("../views/invoicing/toInvoicing/Index.vue"),
    meta: {
      title: "开发票",
    },
  },
  {
    path: "/versionUpdate",
    name: "versionUpdate",
    component: () => import("../views/versionUpdate/Index.vue"),
    meta: {
      title: "版本更新",
    },
  },
  {
    path: "/serviceRules",
    name: "serviceRules",
    component: () => import("../views/serviceRules/Index.vue"),
    meta: {
      title: "换电服务协议",
    },
  },
  {
    path: "/map",
    name: "map",
    component: () => import("../views/map/index.vue"),
    meta: {
      title: "换电网络",
    },
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("../views/privacyPolicy/index.vue"),
    meta: {
      title: "隐私政策",
    },
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () => import("../views/userAgreement/index.vue"),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/batterySwapGuide",
    name: "batterySwapGuide",
    component: () => import("../views/batterySwapGuide/index.vue"),
    meta: {
      title: "换电指南",
    },
  },
  {
    path: "/inviteView",
    name: "inviteView",
    component: () => import("../views/inviteView/index.vue"),
    meta: {
      title: "邀请活动",
    },
  },
  {
    path: "/inviteViewV2",
    name: "inviteViewV2",
    component: () => import("../views/inviteViewV2/index.vue"),
    meta: {
      title: "邀请活动",
    },
  },
  {
    path: "/serviceContract",
    name: "serviceContract",
    component: () => import("../views/serviceContract/index.vue"),
    meta: {
      title: "电卡服务合同",
    },
  },
  {
    path: "/cpCompany",
    name: "cpCompany",
    children: [
      {
        path: "searchVin",
        name: "searchVin",
        component: () => import("../views/cpCompany/searchVin/index.vue"),
        meta: {
          title: "包月卡购买",
        },
      },
      {
        path: "monthlyCard",
        name: "monthlyCard",
        component: () => import("../views/cpCompany/monthlyCard/index.vue"),
        meta: {
          title: "包月卡购买",
        },
      },
      {
        path: "payPage",
        name: "payPage",
        component: () => import("../views/cpCompany/payPage/index.vue"),
        meta: {
          title: "包月卡购买",
        },
      },
      {
        path: "purchaseRecords",
        name: "purchaseRecords",
        component: () => import("../views/cpCompany/purchaseRecords/index.vue"),
        meta: {
          title: "购买记录",
        },
      },
    ],
  },
  {
    path: "/assetMonitoring",
    name: "assetMonitoring",
    component: () => import("../views/assetMonitoring/index.vue"),
    meta: {
      title: "资产实时监控",
    },
  },
  {
    path: "/transferStation",
    name: "transferStation",
    component: () => import("../views/transferStation/index.vue"),
    meta: {
      title: "活动跳转",
    },
  },
];

const router = createRouter({
  // 路由模式：hash模式和history模式
  history: createWebHashHistory(process.env.BASE_URL),
  base: /h5/,
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title ? to.meta.title : "无此网页";
});

export default router;
